import './text-input.scss'
import InputWrapper from "../input-wrapper/input-wrapper"

export default (props) => {

    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        tooltip,
        trailingIcon,
        leadingIcon,
        trailingText,
        defaultValue,
     //   required,
        ...inputProps} = props
    
    return (
        <InputWrapper {...props} inputType="text">
        <span className="group" data-label="Input">
            {leadingIcon && 
            <span className="icon-leading">
                <span className="icon medium" style={{WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${leadingIcon}.svg)`,
                        maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${leadingIcon}.svg)`,
                    color: "currentColor"}}>
                </span>
            </span>}
            <input 
                id={props.id || props.name}
                type="text"
                {...inputProps}
            />
            {trailingIcon && 
                <span className="icon-trailing">
                    <span className="icon medium" style={{WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${trailingIcon}.svg)`,
                        maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${trailingIcon}.svg)`,
                        color: "currentColor"}}>
                    </span>
                </span>
            }
            {trailingText && !trailingIcon &&
                <span className="text-trailing">
                    <p className='text lead'>
                        {trailingText}
                    </p>
                </span>
            }
           
        </span>
    </InputWrapper>
    )
    
}
